import {
  CounterConfig,
  QuickConfirmConfig,
  RoutineType,
  StatusConfig,
  WorkflowQuestionConfig,
  WorkflowQuestionType,
  WorkspaceRoutine,
} from '@gripp/shared-logic';

const SINGLE_STATE_QUESTION_TYPES: Partial<Record<RoutineType, WorkflowQuestionType>> = {
  [RoutineType.Counter]: WorkflowQuestionType.Counter,
  [RoutineType.QuickConfirm]: WorkflowQuestionType.QuickConfirm,
  [RoutineType.Status]: WorkflowQuestionType.Status,
};

/**
 * Counter, QuickConfirm and Status routines are single-question forms whose
 * answer shape is identical to the workflow question of the same name, so the
 * sheet prints them through the same renderer rather than a second set.
 */
export const buildSingleStateQuestion = (
  routine: WorkspaceRoutine
): WorkflowQuestionConfig | undefined => {
  const type = routine.type ? SINGLE_STATE_QUESTION_TYPES[routine.type] : undefined;
  if (!type) return undefined;

  const config = routine.config as Partial<CounterConfig & QuickConfirmConfig & StatusConfig>;

  return {
    ...config,
    id: routine.id,
    name: routine.name ?? config.title ?? '',
    order: 1,
    required: false,
    type,
    instructions: config.instructions,
  };
};
